import "../../css/old.css";
import { useMount } from "ahooks";
import general from "../../general";

const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export const openUrl = (url) => {
  try {
    if (isIos) {
      window.openWebView(url);
    } else {
      window.maiyou.openUrl(url);
    }
  } catch (e) {
    window.location.href = url;
  }
};

export const openBoxApp = function (package_name, url) {
  try {
    if (isIos) {
      if (url) {
        window.openAppBox(package_name, url);
      } else {
        window.openAppBox(package_name);
      }
    } else {
      if (url) {
        window.maiyou.openApp(package_name, url);
      } else {
        window.maiyou.openApp(package_name);
      }
    }
  } catch (e) {
    if (url) {
      openUrl(url);
    }
  }
};

export const openBoxApp2 = () => {
  const { app, user } = general;

  const downloadBoxUrl = () => {
    if (app.osType == "ios") {
      return `https://webbox2.9917yx.com/#/?agent=${app?.agent}&brand=${app.brand}&userid=${user?.member_id}&username=${app.username}&token=${app.token}`;
    } else {
      return `https://and-new.9917.cn/?gameId=${
        app.brand == "9917" || app.brand == "dawan"
          ? 152
          : app.brand == "97"
          ? 107268
          : app.brand == "fw"
          ? 108330
          : app.brand == "zc"
          ? 107266
          : app.brand == "hiwan"
          ? 102583
          : app.brand == "btwan"
          ? 101828
          : ""
      }&agent=${app?.agent}`;
    }
  };

  if (isIos) {
    var res = openUrl("box9917://");
    if (res == "undefined" || res == undefined) {
      openUrl(downloadBoxUrl());
    }
  } else {
    openBoxApp("com.aoyou.gamebox", downloadBoxUrl());
  }
};

export default () => {
  useMount(() => (window.document.title = "用户中心"));
  return null;
};
